import axios, { AxiosRequestConfig } from "axios";
// @ts-ignore
import qs from "qs";

export const createRFID = async (
  rf_tag: string,
  license_plate: string,
  rt_name: string,
  token: string
) => {
  var data = qs.stringify({
    rf_tag: rf_tag,
    license_plate: license_plate,
    rt_name: rt_name,
  });
  var config: AxiosRequestConfig = {
    method: "post",
    url: "https://pis.distronix.in:5443/api/rfidMaster/createOne",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "x-access-token": token,
    },
    data: data,
  };

  const result = await axios(config)
    .then((result: any) => result)
    .catch((error: any) => {
      console.log(error);
      return error;
    });

  return result;
};
